// extracted by mini-css-extract-plugin
export default {"container":"NoAccess_container__wVCOn"};